// extracted by mini-css-extract-plugin
export default {"projects":"Projects_projects__0sgcm","projectCards":"Projects_projectCards__oAWZq"};